import { render } from "./FrissScore.vue?vue&type=template&id=57d7a6ab&scoped=true&ts=true"
import script from "./FrissScore.vue?vue&type=script&lang=ts"
export * from "./FrissScore.vue?vue&type=script&lang=ts"

import "./FrissScore.vue?vue&type=style&index=0&id=57d7a6ab&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d7a6ab"]])

export default __exports__